export default __webpack_public_path__ + "static/media/clientes-ciclo.c6560d83.png";